import {
  alpha,
  LinearProgress,
  linearProgressClasses,
  styled,
} from '@mui/material';

import { colorByType, ToastTypeEnum } from '../toast.constants';

export const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  marginTop: theme.spacing(6),
  borderRadius: '5px',
  height: '6px',
  [`&.${linearProgressClasses.colorPrimary}`]: {
    background: alpha(theme.palette.common.white, 0.15),
  },
  [`& .${linearProgressClasses.bar}`]: {
    background: colorByType[ToastTypeEnum.LOADING],
    borderRadius: '5px',
  },
}));
